import React from 'react';
import Navbar from './Navbar';  // Ensure Navbar is correctly imported
import SliderPage from './SliderPage';
import AboutUs from './AboutUs';
import Testimonials from './Testimonials';
import VisionMission from './VisionMission';
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';
import Team from './Team';

const Home = () => {
  return (
    <div>
      <Navbar />
      <SliderPage />
      <AboutUs />
      <Testimonials />
      <VisionMission />
      <Team />
      <ConsultationSection />
      <FooterSection />
    </div>
  );
};

export default Home;
